import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "supported-library-element-types"
    }}>{`Supported Library Element Types`}</h1>
    <p>{`This document provides detail on currently supported library element types; the amount of information
here should be enough to get started creating any of these types, however, it may not, in certain circumstances,
be completely comprehensive. This document assumes general familiarity with Libraries and the element
creation process.`}</p>
    <p>{`The element types are:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`MIME Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Graphics`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.image+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Brush`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.brush+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Layer Style`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.layerstyle+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Template`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.template+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.color+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Color Theme`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.colortheme+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Gradient`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.gradient+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Pattern`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.pattern+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Character Style`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.characterstyle+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Paragraph Style`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.paragraphstyle+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.text+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Look`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.look+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Video`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.video+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Animation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.animation+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Motion Graphic Template`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.graphic+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Model`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.3d+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Material`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.material+dcx`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Light`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`application/vnd.adobe.element.light+dcx`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "graphics"
    }}>{`Graphics`}</h2>
    <h3 {...{
      "id": "element-type"
    }}>{`Element Type`}</h3>
    <p>{`application/vnd.adobe.element.image+dcx`}</p>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`Represents any still image.`}</p>
    <h3 {...{
      "id": "allowed-representation-types"
    }}>{`Allowed Representation Types`}</h3>
    <p>{`The set of types that is allowed is quite expansive, and changes frequently. This includes common image types, file
formats specific to different Creative Cloud applications, and, in certain contexts, types we can convert to images, including
things like PDFs, Word documents, etc. However, the most common types are:`}</p>
    <ul>
      <li parentName="ul">{`image/gif`}</li>
      <li parentName="ul">{`image/jpeg`}</li>
      <li parentName="ul">{`image/jpg`}</li>
      <li parentName="ul">{`image/png`}</li>
      <li parentName="ul">{`image/svg+xml`}</li>
    </ul>
    <h3 {...{
      "id": "representation-requirements"
    }}>{`Representation Requirements`}</h3>
    <ul>
      <li parentName="ul">{`if the primary representation is not a bitmap, a fullsize bitmap rendition that can be used for thumbnails`}</li>
      <li parentName="ul">{`optionally, other renditions depending on what apps may consume the image`}</li>
    </ul>
    <h3 {...{
      "id": "example-postlibraryelement-payload"
    }}>{`Example postLibraryElement Payload`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "name": "my-cool-image",
  "type": "application/vnd.adobe.element.image+dcx",
  "client": {
    "deviceId": "MY_COOL_DEVICE_ID",
    "device": "MY_COOL_DEVICE",
    "app": "MY_COOL_APP"
  },
  "representations": [
    {
      "type": "image/svg+xml",
      "relationship": "primary",
      "storage_href": "https://cc-api-storage-stage.adobe.io/assets/adobe-libraries/4dc522a7-af3d-4274-986c-bb1f59bb20d0/3f4d2883-f7e5-4d64-bec1-f153ae5d80af"
    },
    {
      "type": "image/png",
      "relationship": "rendition",
      "storage_href": "https://cc-api-storage-stage.adobe.io/assets/adobe-libraries/4dc522a7-af3d-4274-986c-bb1f59bb20d0/ec13e4e1-1c56-4d84-89ad-8df52f42ae8a"
    }
  ]
}
`}</code></pre>
    <h2 {...{
      "id": "color"
    }}>{`Color`}</h2>
    <h3 {...{
      "id": "element-type-1"
    }}>{`Element Type`}</h3>
    <p>{`application/vnd.adobe.element.color+dcx`}</p>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`Represents a single color.`}</p>
    <h3 {...{
      "id": "allowed-representation-types-1"
    }}>{`Allowed Representation Types`}</h3>
    <h4 {...{
      "id": "applicationvndadobecolorjson"
    }}>{`application/vnd.adobe.color+json`}</h4>
    <p>{`Every color representation requires a property named "color#data", the value of which is a JSON structure
that represents the color. This structure may have the following properties:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Values`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`mode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The type of color space (e.g. RGB, CMYK, etc...)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"RGB", "CMYK", "Lab", "Gray", "HSB", "RGB.tint", "CMYK.tint", "Lab.tint"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`profileName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the color profile (each mode has a default color profile if omitted, so this is always defined).`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String - Possible values may depend on app and region`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Default value depends on mode - see below.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Way of constructing the color (e.g. is it mixed or using a specific ink). See table below for more detailed explanation.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"process", "spot", "registration", "none"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"process"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Value of the color based on the mode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Value depends on mode - see table below.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`alpha`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Opacity of the color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Floating point number in the range 0..1 (0.0 is fully transparent, and 1.0 is fully opaque)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`spotColorName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the spot color (only relevant for type = "spot")`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Required only for colors of type "spot"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String - Name of the spot color (catalog + name)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`'value' will change depending on 'mode' as follows:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Mode`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default profileName`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CMYK`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`U.S. Web Coated (SWOP) v2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Four properties named "c", "m", "y", and "k". The value of each property is a floating point number in the range 0..100.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CMYK.tint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`U.S. Web Coated (SWOP) v2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The same properties as the CMYK mode, with an additional property named "tint". The value of "tint" is a floating point number in the range 0..100.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Gray`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Dot Gain 20%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A single floating point number in the range 0..100.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`HSB`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sRGB IEC61966-2.1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Three properties named "h", "s", and "b". The value of "h" is a floating point number in the range of 0..360 and "s" and "b" are floating point numbers in the range of 0..100`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Lab`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`CIELAB D50`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Three properties named "l", "a", and "b". The value of "L" is a floating point number in the range 0..100. The values of "a" and "b" are floating point numbers in the range -128..127.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Lab.tint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`CIELAB D50`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The same properties as the Lab mode, with an additional property named "tint". The value of "tint" is a floating point number in the range 0..100.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`RGB`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sRGB IEC61966-2.1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Three properties named "r", "g", and "b". The value of each property is a floating point number in the range 0..255.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`RGB.tint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sRGB IEC61966-2.1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The same properties as the RGB mode, with an additional property named "tint". The value of "tint" is a floating point number in the range 0..100.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The different color "types" are as follows - note that all colors require the process values for the color mode, even if they're of a non-process type, so that they're supported in apps that only understand process colors.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Additional Properties`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Comments`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`none`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A "none" color is used in print to mean "don't apply any ink"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`None colors should set the process values to 0% with alpha 0 (e.g. CMYK 0,0,0,0, alpha 0)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`process`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A process color is one that's obtained by mixing different properties (e.g. mixing inks or light). This is the default type of color.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Note: Even if a color has type other than process, it must still include a value for the color based on the table above. (e.g. CMYK must always have c, m, y, k fields).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`registration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A registration color is used in print to mean "apply all the inks" (e.g. 100% process colors plus 100% of any spot color).`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If the type is “registration” – apps that understand this will interpret as a registration color, otherwise will use the process values. Registration colors should set the process values to 100%, with alpha 1 (e.g. CMYK 100,100,100,100, alpha 1)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`spot`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"spotColorName": Name of the spot color (catalog + name).`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A spot color is used in print to mean a specific ink (e.g. using a Pantone color), rather than mixing inks.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The spotColorName property holds the name of the catalog and color of the spot color, e.g. "Pantone Metallic Gold 875"`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "representation-requirements-1"
    }}>{`Representation Requirements`}</h3>
    <ul>
      <li parentName="ul">{`At least one RGB representation`}</li>
      <li parentName="ul">{`optionally, other renditions`}</li>
    </ul>
    <h3 {...{
      "id": "example-postlibraryelement-payload-1"
    }}>{`Example postLibraryElement Payload`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "name": "my-color",
  "type": "application/vnd.adobe.element.color+dcx",
  "client": {
    "deviceId": "MY_COOL_DEVICE_ID",
    "device": "MY_COOL_DEVICE",
    "app": "MY_COOL_APP"
  },
  "representations": [
    {
      "type": "application/vnd.adobe.color+json",
      "relationship": "primary",
      "color#data": {
        "mode": "CMYK",
        "value": {
          "c": 100,
          "m": 79.0585160255432,
          "y": 39.5178139209747,
          "k": 31.2565803527832
        },
        "type": "process"
      }
    },
    {
      "type": "application/vnd.adobe.color+json",
      "relationship": "rendition",
      "color#data": {
        "mode": "RGB",
        "value": {
          "r": 12.7313232421875,
          "g": 56.0341644287109,
          "b": 89.8001861572266
        },
        "type": "process"
      }
    }
  ]
}
`}</code></pre>
    <h2 {...{
      "id": "color-theme"
    }}>{`Color Theme`}</h2>
    <h3 {...{
      "id": "element-type-2"
    }}>{`Element Type`}</h3>
    <p>{`application/vnd.adobe.element.colortheme+dcx`}</p>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`Represents a color theme, a collection of 5 colors.`}</p>
    <h3 {...{
      "id": "allowed-representation-types-2"
    }}>{`Allowed Representation Types`}</h3>
    <h4 {...{
      "id": "applicationvndadobecolorthemejson"
    }}>{`application/vnd.adobe.colortheme+json`}</h4>
    <p>{`The colortheme JSON requires a property named "colortheme#data", containing a structure with the following properties:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Values`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`themeId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Theme ID as stored in Adobe Color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`tags`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of tags to help you classify your color theme, e.g., "Citrus", "Colorful", etc.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`baseSwatchIndex`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Index of the base swatch in the swatches array, used mostly by apps while editing.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0, 1, 2, 3`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`rule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rule that was applied to base swatch to generate the other swatches.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Analogous, Complimentary, Monochromatic, Triad, Custom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`mood`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rule that was applied while picking colors from a picture.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Colorful, Bright, Muted, Dark, Custom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`swatches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`See below.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "swatches"
    }}>{`Swatches`}</h4>
    <p>{`Swatches should contain an array of exactly 5 arrays. Each array contains objects in the format defined for
Color that are all representations of the same color and must include at least one RGB representation. The primary
representation of any single color will always be at index 0 in the array.`}</p>
    <h3 {...{
      "id": "representation-requirements-2"
    }}>{`Representation Requirements`}</h3>
    <ul>
      <li parentName="ul">{`A application/vnd.adobe.colortheme+json primary representation.`}</li>
    </ul>
    <h3 {...{
      "id": "example-postlibraryelement-payload-2"
    }}>{`Example postLibraryElement Payload`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "name": "my-cool-colortheme",
  "type": "application/vnd.adobe.element.colortheme+dcx",
  "client": {
    "deviceId": "MY_COOL_DEVICE_ID",
    "device": "MY_COOL_DEVICE",
    "app": "MY_COOL_APP"
  },
  "representations": [
    {
      "type": "application/vnd.adobe.colortheme+json",
      "relationship": "primary",
      "colortheme#data": {
        "tags": ["tag1", "tag2"],
        "baseSwatchIndex": 0,
        "rule": "analogous",
        "mood": "colorful",
        "swatches": [
          [
            {
              "mode": "CMYK",
              "value": {
                "c": 0,
                "m": 12,
                "y": 37,
                "k": 30
              }
            },
            {
              "mode": "RGB",
              "value": {
                "r": 179,
                "g": 158,
                "b": 113
              },
              "type": "process",
              "profileName": "sRGB IEC61966-2.1"
            }
          ],
          [
            {
              "mode": "CMYK",
              "value": {
                "c": 17,
                "m": 0,
                "y": 7,
                "k": 0
              }
            },
            {
              "mode": "RGB",
              "value": {
                "r": 212,
                "g": 255,
                "b": 237
              },
              "type": "process",
              "profileName": "sRGB IEC61966-2.1"
            }
          ],
          [
            {
              "mode": "CMYK",
              "value": {
                "c": 0,
                "m": 8,
                "y": 27,
                "k": 0
              }
            },
            {
              "mode": "RGB",
              "value": {
                "r": 255,
                "g": 234,
                "b": 187
              },
              "type": "process",
              "profileName": "sRGB IEC61966-2.1"
            }
          ],
          [
            {
              "mode": "CMYK",
              "value": {
                "c": 9,
                "m": 37,
                "y": 0,
                "k": 20
              }
            },
            {
              "mode": "RGB",
              "value": {
                "r": 185,
                "g": 129,
                "b": 204
              },
              "type": "process",
              "profileName": "sRGB IEC61966-2.1"
            }
          ],
          [
            {
              "mode": "CMYK",
              "value": {
                "c": 8,
                "m": 32,
                "y": 0,
                "k": 30
              }
            },
            {
              "mode": "RGB",
              "value": {
                "r": 164,
                "g": 122,
                "b": 179
              },
              "type": "process",
              "profileName": "sRGB IEC61966-2.1"
            }
          ]
        ]
      }
    }
  ]
}
`}</code></pre>
    <h2 {...{
      "id": "gradient"
    }}>{`Gradient`}</h2>
    <h3 {...{
      "id": "element-type-3"
    }}>{`Element Type`}</h3>
    <p>{`application/vnd.adobe.element.gradient+dcx`}</p>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`Represents a collection of colors (color stops), combined with some algorithm for interpolating between them.`}</p>
    <h3 {...{
      "id": "allowed-representation-types-3"
    }}>{`Allowed Representation Types`}</h3>
    <p>{`application/vnd.adobe.gradient+json`}</p>
    <p>{`You may also encounter a representation type of "application/vnd.adobe.gradient.noise+json",
which represents a `}<em parentName="p">{`noise gradient`}</em>{`. This is a custom gradient type used by Photoshop as a mechanism
to represent textures; this gradient type contains additional fields to the ones below.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Values`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Notes`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The gradient type. Linear gradients are applied along a single axis. Radial gradients are applied outward from a single point.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string, one of "linear", "radial"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`noise gradients use "noise"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`angle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The angle which the gradient is applied across the bounding box.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number from 0-360 inclusive (degrees)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The angle is measured counterclockwise from the positive x-axis.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`aspectRatio`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`For radial gradients, the ratio between the x and y axis of the ellipse (y/x).`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`positive non-zero number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Applies only to radial gradients.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`scale`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`For radial gradients, scale factor of the x-axis of the ellipse, relative to the width of the bounding box of the container being filled.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`positive non-zero number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Applies only to radial gradients.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`centerPoint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`For radial gradients, the center point is the point that the gradient radiates out from.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`a "Point" object (see below)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(see below)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Applies only to radial gradients.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`stops`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`an array of arrays of "Color" objects (e.g., "swatches" property in the Colortheme element above, without the limitation of 5 colors)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Must include at least RGB format, may include additional formats. Do not include alpha channel.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`opacities`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`an array of "Opacity" objects (see below)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(see below)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`interpolation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string, one of "linear", "euclidean", "spline"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"linear"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Point:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Attribute`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Values`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Notes`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`x-axis of centerpoint, relative to edges of bounding box.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number between -1 and 1 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.5`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A percentage of the bounding box.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number between -1 and 1 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.5`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Opacity:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Attribute`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Values`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Notes`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`opacity`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number from 0 to 1 inclusive`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`midpoint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number from 0 to 1 inclusive`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0.5`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`offset`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number from 0 to 1 inclusive`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`default value will be interpolated relative to index in array, e.g., "`}{`[ { opacity: 1, offset: 0 }, { opacity: 1, offset: 1 } ]`}{`"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "representation-requirements-3"
    }}>{`Representation Requirements`}</h3>
    <ul>
      <li parentName="ul">{`Primary application/vnd.adobe.gradient+json representation.`}</li>
    </ul>
    <h3 {...{
      "id": "example-postlibraryelement-payload-3"
    }}>{`Example postLibraryElement Payload`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "name": "my-cool-gradient",
  "type": "application/vnd.adobe.element.gradient+dcx",
  "client": {
    "deviceId": "MY_COOL_DEVICE_ID",
    "device": "MY_COOL_DEVICE",
    "app": "MY_COOL_APP"
  },
  "representations": [
    {
      "id": "d8453c78-4dd4-44c0-ab18-0114e171aa84",
      "type": "application/vnd.adobe.gradient+json",
      "relationship": "primary",
      "gradient#data": {
        "type": "linear",
        "angle": 0,
        "stops": [
          {
            "color": [
              {
                "mode": "RGB",
                "value": {
                  "r": 102.0,
                  "g": 238.0,
                  "b": 207.0
                },
                "type": "process",
                "profileName": "sRGB IEC61966-2.1"
              },
              {
                "mode": "CMYK",
                "value": {
                  "c": 48,
                  "m": 0.0,
                  "y": 30.0,
                  "k": 0.0
                },
                "type": "process",
                "profileName": "U.S. Web Coated (SWOP) v2"
              }
            ],
            "midpoint": 0,
            "offset": 0
          },
          {
            "color": [
              {
                "mode": "RGB",
                "value": {
                  "r": 74.0,
                  "g": 96.0,
                  "b": 204.0
                },
                "type": "process",
                "profileName": "sRGB IEC61966-2.1"
              },
              {
                "mode": "CMYK",
                "value": {
                  "c": 77,
                  "m": 67.0,
                  "y": 0.0,
                  "k": 0.0
                },
                "type": "process",
                "profileName": "U.S. Web Coated (SWOP) v2"
              }
            ],
            "midpoint": 0.5,
            "offset": 1.0
          }
        ],
        "opacities": [
          {
            "opacity": 1.0,
            "midpoint": 0,
            "offset": 0
          },
          {
            "opacity": 1.0,
            "midpoint": 0.5,
            "offset": 1.0
          }
        ],
        "interpolation": "linear"
      }
    }
  ]
}
`}</code></pre>
    <h2 {...{
      "id": "character-style"
    }}>{`Character Style`}</h2>
    <h3 {...{
      "id": "element-type-4"
    }}>{`Element Type`}</h3>
    <p>{`application/vnd.adobe.element.characterstyle+dcx`}</p>
    <h3 {...{
      "id": "description-4"
    }}>{`Description`}</h3>
    <p>{`Represents a collection of styles that may be applied to characters within some text.`}</p>
    <h3 {...{
      "id": "allowed-representation-types-4"
    }}>{`Allowed Representation Types`}</h3>
    <h4 {...{
      "id": "applicationvndadobecharacterstylejson"
    }}>{`application/vnd.adobe.characterstyle+json`}</h4>
    <p>{`Every representation of type "application/vnd.adobe.characterstyle+json" should contain a property
named "characterstyle#data". The value of characterstyle#data should be a dictionary containing at least
one property. Each of these properties should represent a style.`}</p>
    <p>{`There are three categories of styles: standard CSS styles, with the name in camelCase instead
of kebab-case, e.g. "lineHeight" instead of "line-height"; internal styles that are valid across multiple
adobe applications, the names of which will be in camelCase and prefixed with "adbe', e.g., "adbeFont";
and, internal styles only valid within a single application, which are typically prefixed with "adbe"
followed by an abbreviation of the application name and then the style name, e.g.,
"adbeIlstOpenTypePosition" for a style only valid for Adobe Illustrator. Styles in this third
category may change frequently depending on application-specific requirements.`}</p>
    <p>{`For any style that may have an enumerated value, the value will just be a string, e.g., {"fontStyle": "italic"}.
For any style that may require a list of items, the value should be represented as an array,
e.g., {"fontFeatureSettings": `}{`[`}{`"aalt", "liga", "flac"`}{`]`}{`}. For any style that is measured with
some css unit, the property value should be a dictionary containing a "type" and "value" property
that separate these components, e.g., "56vm" would be represented as {"value": 56, "type": "vm"}.
Additionally, most styles will have their own special requirements.`}</p>
    <p>{`Due to the variety of constraints within each style, application-derived interrelationships between
styles, and, the possibility that some will change over time in accordance with application-specific
requirements, it may be helpful to try prototyping character styles within a Creative Cloud app first, before
attempting to create them `}<em parentName="p">{`ex situ`}</em>{`.`}</p>
    <p>{`Some frequently used styles:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Sample Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`baselineShift`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Same as baseline shift in Photoshop and Illustrator.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{"value": 0, "type": "em"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of colors as in the application/vnd.adobe.color+json representation above, with the primary representation as the first element in the array.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`see documentation above`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fontFamily`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Font family. This is not used by Photoshop and Illustrator as more exact information is used to reliably determine the font.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"Helvetica"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fontFeatureSettings`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of Open Type features; c.f. `}{`[http://www.microsoft.com/typography/otspec/featurelist.htm]`}{`.`}<br />{`Illustrator supports: ornm, ordn, frac, titl, swsh, dlig, clig, liga, salt, sups, subs, c2sc, smcp`}<br />{`Photoshop supports: ordn, frac, titl, swsh, dlig, liga, salt, sups, subs, ornm, onum, smcp, clig`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[`}{`"liga", "ordn"`}{`]`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fontSize`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TODO: get clarification on this`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{"value": 20, "type": "pt"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fontStyle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TODO: get clarification on this`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"oblique"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fontWeight`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TODO: get clarification on this`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"bold"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`letterSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Corresponds to tracking attribute in Illustrator and Photoshop.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{"value": 1, "type": "em"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`lineHeight`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Corresponds to leading property in Illustrator and Photoshop.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{"value": 21, "type": "px"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`textDecoration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Follows the CSS definition of text-decoration; represented as an array of strings.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`textTransform`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Follows the CSS definition of text-transform.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[`}{`"line-through", "underline"`}{`]`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`whiteSpace`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Used to correspond to the noBreak property in Photoshop and Illustrator. Only supports the value "nowrap", other values are ignored.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"nowrap"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeFont`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`contains a Font object (see below)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{ "family": "Helvetica Neue", "name": "Helvetica Neue Bold", "postScriptName": "HelveticaNeue-Bold", "style": "Bold" }`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "applicationvndadobeindesign-idms"
    }}>{`application/vnd.adobe.indesign-idms`}</h4>
    <p>{`A character style may also be represented as an InDesign snippet.`}</p>
    <h3 {...{
      "id": "representation-requirements-4"
    }}>{`Representation Requirements`}</h3>
    <ul>
      <li parentName="ul">{`A mandatory application/vnd.adobe.characterstyle+json representation, which may have the primary relationship,
or the rendition relationship, in the case where an InDesign snippet is used as the primary.`}</li>
      <li parentName="ul">{`Optionally, a primary representation of type application/vnd.adobe.indesign-idms, if the json representation is not primary.`}</li>
      <li parentName="ul">{`A mandatory thumbnail rendition, e.g, of type "image/png".`}</li>
    </ul>
    <h3 {...{
      "id": "example-postlibraryelement-payload-4"
    }}>{`Example postLibraryElement Payload`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "name": "My character style",
  "type": "application/vnd.adobe.element.characterstyle+dcx",
  "client": {
    "deviceId": "DEV_ID",
    "device": "DEV",
    "app": "APP"
  },
  "representations": [
    {
      "id": "76ab62cd-f0fd-4778-ae4f-ce7a2aa4d7d0",
      "type": "application/vnd.adobe.characterstyle+json",
      "relationship": "primary",
      "is_full_size": false,
      "is_external_link": false,
      "preferredThumbnail": false,
      "representation_order": 0,
      "characterstyle#data": {
        "color": [
          {
            "mode": "RGB",
            "value": {
              "r": 0,
              "g": 0,
              "b": 0
            },
            "type": "process"
          }
        ],
        "adbeFont": {
          "family": "Helvetica Neue",
          "name": "HelveticaNeue",
          "postScriptName": "HelveticaNeue",
          "style": "Regular"
        },
        "fontFamily": "Helvetica Neue",
        "fontSize": {
          "type": "pt",
          "value": 18
        },
        "adbeIlstAlignment": "StyleRunAlignmentType.ROMANBASELINE",
        "adbeIlstBaselineDirection": "BaselineDirectionType.Standard",
        "adbeIlstBaselinePosition": "FontBaselineOption.NORMALBASELINE",
        "adbeIlstCapitalization": "FontCapsOption.NORMALCAPS",
        "adbeIlstFigureStyle": "FigureStyleType.DEFAULTFIGURESTYLE",
        "adbeIlstOpenTypePosition": "FontOpenTypePositionOption.OPENTYPEDEFAULT",
        "adbeIlstWariChuJustification": "WariChuJustificationType.WARICHUAUTOJUSTIFY",
        "adbeIlstAkiLeft": -1,
        "adbeIlstAkiRight": -1,
        "adbeAutoLeading": true,
        "adbeIlstConnectionForms": false,
        "adbeHorizontalScale": 100,
        "lineHeight": {
          "type": "pt",
          "value": 21.6000003814697
        },
        "adbeIlstOverprintFill": false,
        "adbeIlstOverprintStroke": false,
        "adbeIlstProportionalMetrics": false,
        "adbeIlstRotation": 0,
        "adbeIlstTateChuYokoHorizontal": 0,
        "adbeIlstTateChuYokoVertical": 0,
        "fontFeatureSettings": ["clig", "liga"],
        "adbeIlstTsume": 0,
        "adbeVerticalScale": 100,
        "adbeIlstWariChuCharactersAfterBreak": 2,
        "adbeIlstWariChuCharactersBeforeBreak": 2,
        "adbeIlstWariChuEnabled": false,
        "adbeIlstWariChuLineGap": 0,
        "adbeIlstWariChuLines": 2,
        "adbeIlstWariChuScale": 50
      }
    },
    {
      "type": "image/png",
      "relationship": "rendition",
      "storage_href": "https://cc-api-storage-stage.adobe.io/id/urn:aaid:sc:US:efb1969b-fed5-4381-836e-6d7a97a14fbf?component_id=602eb2e4-d86d-481f-adc2-d751fc5ca961",
      "content_length": 158356,
      "etag": "\\"9b4fb626b2ea694ceceda1b5caa7463c\\"",
      "md5": "m0+2JrLqaUzs7aG1yqdGPA==",
      "version": "0"
    }
  ]
}
`}</code></pre>
    <h2 {...{
      "id": "paragraph-style"
    }}>{`Paragraph Style`}</h2>
    <h3 {...{
      "id": "element-type-5"
    }}>{`Element Type`}</h3>
    <p>{`application/vnd.adobe.element.paragraphstyle+dcx`}</p>
    <h3 {...{
      "id": "description-5"
    }}>{`Description`}</h3>
    <p>{`Represents a collection of styles that may be applied to paragraphs.`}</p>
    <h3 {...{
      "id": "allowed-representation-types-5"
    }}>{`Allowed Representation Types`}</h3>
    <h4 {...{
      "id": "applicationvndadobeparagraphstylejson"
    }}>{`application/vnd.adobe.paragraphstyle+json`}</h4>
    <p>{`This representation type is almost identical to application/vnd.adobe.characterstyle+json,
except that the set of styles that are considered valid is a superset including all valid
character styles alongside a set of styles that are only valid for paragraphs.`}</p>
    <p>{`Some frequently used paragraph styles:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Sample Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeParaAlignment`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The paragraph alignment. One of:`}<br /><br />{` "Alignment.LEFT_ALIGN"`}<br />{`"Alignment.CENTER_ALIGN"`}<br />{`"Alignment.RIGHT_ALIGN"`}<br />{`"Alignment.LEFT_JUSTIFIED"`}<br />{`"Alignment.CENTER_JUSTIFIED"`}<br />{`"Alignment.RIGHT_JUSTIFIED"`}<br />{`"Alignment.FULLY_JUSTIFIED"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"Alignment.CENTER_ALIGN"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeLeftIndent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The width of the left indent.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{"value": 20, "type": "pt"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeFirstLineIndent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The amount to indent the first line.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{"value": 20, "type": "pt"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeRightIndent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The width of the right indent.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{"value": 20, "type": "pt"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeSpaceBefore`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The height of the paragraph space above.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{"value": 20, "type": "pt"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeSpaceAfter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The height of the paragraph space below.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{"value": 20, "type": "pt"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeMinimumWordSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The minimum word spacing (in percent). A number between 0 and 1000 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`50`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeDesiredWordSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The desired word spacing (in percent). A number between 0 and 1000 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`50`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeMaximumWordSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The maximum word spacing (in percent). A number between 0 and 1000 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`50`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeMinimumLetterSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The minimum letter spacing (in percent). A number between -100 and 500 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`400`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeDesiredLetterSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The desired letter spacing (in percent). A number between -100 and 500 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`400`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeMaximumLetterSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The minimum letter spacing (in percent). A number between -100 and 500 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`400`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeMinimumGlyphScaling`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The minimum width of an individual character (in percent). A number between 50 and 200 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`100`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeDesiredGlyphScaling`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The desired width of an individual character (in percent). A number between 50 and 200 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`100`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeMaximumGlyphScaling`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The maximum width of an individual character (in percent). A number between 50 and 200 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`50`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeParaAutoLeading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The percentage to use for auto leading. A number between 0 and 500 inclusive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`100`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adbeSingleWordJustification`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The alignment for lines of text in a paragraph that contain a single word. One of:`}<br /><br />{`"Justification.FULLY_JUSTIFIED”`}<br />{`”Justification.LEFT_ALIGN”`}<br />{`”Justification.CENTER_ALIGN”`}<br />{`"Justification.RIGHT_ALIGN"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"Justification.RIGHT_ALIGN"`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "representation-requirements-5"
    }}>{`Representation Requirements`}</h3>
    <p>{`The requirements are identical to the character style element, except an application/vnd.adobe.paragraphstyle+json
primary or rendition representation is expected instead of an application/vnd.adobe.characterstyle+json element:`}</p>
    <ul>
      <li parentName="ul">{`A mandatory application/vnd.adobe.paragraphstyle+json representation, which may have the primary relationship,
or the rendition relationship, in the case where an InDesign snippet is used as the primary.`}</li>
      <li parentName="ul">{`Optionally, a primary representation of type application/vnd.adobe.indesign-idms, if the json representation is not primary.`}</li>
      <li parentName="ul">{`A mandatory thumbnail rendition, e.g, of type "image/png".`}</li>
    </ul>
    <h3 {...{
      "id": "example-postlibraryelement-payload-5"
    }}>{`Example postLibraryElement Payload`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "adbeParaAlignment": "Alignment.CENTER_ALIGN",
  "adbeLeftIndent": { "type": "pt", "value": 12 },
  "adbeHyphenateWordsLongerThan": 10,
  "adbeHyphenation": true
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      